import { GroupLifeSignup } from 'components/groupLifeSection/signup/Signup'
import { GetStaticProps } from 'next'
import { getIntlProps } from 'utils/i18n/getIntlProps'

export default function GroupLifeSignupPage() {
  return <GroupLifeSignup />
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  return {
    props: { ...(await getIntlProps(ctx, 'group_life')) },
  }
}
